import {useState} from 'react';

interface OrganizerItemProps {
  name: string;
  description: string;
  onSelect: () => void;
}

export const OrganizerSearchItem: React.FC<OrganizerItemProps> = ({
  name,
  description,
  onSelect,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const cardStyle: React.CSSProperties = {
    backgroundColor: isHovered ? '#2a2a2a' : '#222',
    padding: '25px',
    borderRadius: '15px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '2px solid transparent',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    transform: isHovered ? 'translateY(-3px)' : 'translateY(0)',
    boxShadow: isHovered
      ? '0 8px 20px rgba(0,0,0,0.4)'
      : '0 4px 10px rgba(0,0,0,0.2)',
    width: '100%',
    boxSizing: 'border-box',
  };

  return (
    <div
      style={cardStyle}
      onClick={onSelect}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      <h3 style={{color: '#fff', margin: 0, fontSize: '1.4rem'}}>{name}</h3>
      <p
        style={{color: '#aaa', margin: 0, fontSize: '1rem', lineHeight: '1.4'}}>
        {description}
      </p>
    </div>
  );
};
